"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionControllerNumber = void 0;
const Flag_1 = __importDefault(require("@opsbase/lib-issue/Flag"));
const compressFormQuestionOption_1 = __importDefault(require("../../compress/compressFormQuestionOption"));
const FormQuestionType_1 = __importDefault(require("../../FormQuestionType"));
const formQuestionOptionsAreSame_1 = __importDefault(require("../../helpers/formQuestionOptionsAreSame"));
const getQuestionConfig_1 = __importDefault(require("../../helpers/getQuestionConfig"));
const createFormQuestionConfigBase_1 = __importDefault(require("../../mutations/createFormQuestionConfigBase"));
const createFormQuestionOption_1 = __importDefault(require("../../mutations/createFormQuestionOption"));
const DefaultFormQuestionController_1 = require("../DefaultFormQuestionController");
exports.QuestionControllerNumber = Object.assign(Object.assign({}, DefaultFormQuestionController_1.DefaultFormQuestionController), { areSame: (a, b) => {
        if (a.type !== FormQuestionType_1.default.NUMBER || b.type !== FormQuestionType_1.default.NUMBER)
            return false;
        if (!DefaultFormQuestionController_1.DefaultFormQuestionController.areSame(a, b))
            return false;
        const aConfig = a.config[FormQuestionType_1.default.NUMBER];
        const bConfig = b.config[FormQuestionType_1.default.NUMBER];
        if (aConfig.minValue !== bConfig.minValue)
            return false;
        if (aConfig.maxValue !== bConfig.maxValue)
            return false;
        if (aConfig.precisionValue !== bConfig.precisionValue)
            return false;
        if (!(0, formQuestionOptionsAreSame_1.default)(aConfig.lessThan, bConfig.lessThan))
            return false;
        return (0, formQuestionOptionsAreSame_1.default)(aConfig.moreThan, bConfig.moreThan);
    }, compress: (q) => {
        var _a;
        const config = (0, getQuestionConfig_1.default)(FormQuestionType_1.default.NUMBER, q);
        //temp - remove in two three days
        const hasDefaultMinMaxValue = config.maxValue === 10 && config.minValue === 0;
        return {
            [FormQuestionType_1.default.NUMBER]: Object.assign(Object.assign({}, config), { maxValue: hasDefaultMinMaxValue ? undefined : config.maxValue, minValue: hasDefaultMinMaxValue ? undefined : config.minValue, precisionValue: (_a = config.precisionValue) !== null && _a !== void 0 ? _a : undefined, lessThan: (0, compressFormQuestionOption_1.default)(config.lessThan), moreThan: (0, compressFormQuestionOption_1.default)(config.moreThan) }),
        };
    }, createConfig: (o = {}) => {
        return Object.assign(Object.assign(Object.assign({}, (0, createFormQuestionConfigBase_1.default)({ scoring: exports.QuestionControllerNumber.canScore() })), (o || {})), { lessThan: (0, createFormQuestionOption_1.default)(Object.assign({ label: '< ', flag: Flag_1.default.ORANGE }, ((o === null || o === void 0 ? void 0 : o.lessThan) || {}))), moreThan: (0, createFormQuestionOption_1.default)(Object.assign({ label: '> ', flag: Flag_1.default.ORANGE }, ((o === null || o === void 0 ? void 0 : o.moreThan) || {}))) });
    }, createExampleConfig: () => {
        return exports.QuestionControllerNumber.createConfig({
            lessThan: (0, createFormQuestionOption_1.default)({
                label: '< ',
                flag: Flag_1.default.RED,
                value: 0,
            }),
            moreThan: (0, createFormQuestionOption_1.default)({
                label: '> ',
                flag: Flag_1.default.ORANGE,
                value: 4,
            }),
        });
    } });
exports.default = exports.QuestionControllerNumber;
